import { requestApi } from './Api';

export const listPhysicalAssets = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/physical_assets/list',
    params
  });

export const upsertPhysicalAsset = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/physical_assets/upsert',
    params
  });
